const EmptyState = ({
  title = "No activity in this range",
  description = "Try a wider date range, or check back once events start collecting views.",
  actionLabel,
  onAction,
}) => (
  <div className="ea-empty-state">
    <i className="material-icons ea-empty-state__icon">insights</i>
    <p className="ea-empty-state__title">{title}</p>
    <p className="ea-empty-state__description">{description}</p>
    {actionLabel && onAction && (
      <button type="button" className="btn btn-outline-secondary" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
